(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _Menu2 = require('../../common/Menu');

var _Menu3 = _interopRequireDefault(_Menu2);

var _MenuItem = require('../../common/MenuItem');

var _MenuItem2 = _interopRequireDefault(_MenuItem);

var _Iterator = require('../../common/Iterator');

var _Iterator2 = _interopRequireDefault(_Iterator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CafeMenu = function (_Menu) {
  _inherits(CafeMenu, _Menu);

  function CafeMenu() {
    _classCallCheck(this, CafeMenu);

    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(CafeMenu).call(this));

    _this.addItem("Express", "Coffee from machine", false, 0.99);
    _this.addItem("Long with water", "Coffee with a lot of water", false, 1.20);
    _this.addItem("On the rocks", "Coffee with ice", false, 2.00);
    return _this;
  }

  _createClass(CafeMenu, [{
    key: 'createIterator',
    value: function createIterator() {
      return new _Iterator2.default(this.menuItems);
    }
  }, {
    key: 'addItem',
    value: function addItem(name, description, isVegetarian, price) {
      _get(Object.getPrototypeOf(CafeMenu.prototype), 'addItem', this).call(this, new _MenuItem2.default(name, description, isVegetarian, price));
    }
  }]);

  return CafeMenu;
}(_Menu3.default);

exports.default = CafeMenu;

},{"../../common/Iterator":6,"../../common/Menu":7,"../../common/MenuItem":8}],2:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _Menu2 = require('../../common/Menu');

var _Menu3 = _interopRequireDefault(_Menu2);

var _MenuItem = require('../../common/MenuItem');

var _MenuItem2 = _interopRequireDefault(_MenuItem);

var _Iterator = require('../../common/Iterator');

var _Iterator2 = _interopRequireDefault(_Iterator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MAX_ITEMS = 6;

var LunchMenu = function (_Menu) {
  _inherits(LunchMenu, _Menu);

  function LunchMenu() {
    _classCallCheck(this, LunchMenu);

    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(LunchMenu).call(this));

    _this.addItem("Vegetarian BLT", "(Fakin') Bacon with lettuce and tomato on whole wheat", true, 2.99);
    _this.addItem("BLT", "Bacon with lettuce and tomato on whole wheat", false, 2.99);
    _this.addItem("Soup of the day", "Soup of the day, with a side of potato salad", false, 3.29);
    _this.addItem("Hotdog", "A hotdog with saurkraut, relish, onions, topped with cheese", false, 3.05);
    return _this;
  }

  _createClass(LunchMenu, [{
    key: 'createIterator',
    value: function createIterator() {
      return new _Iterator2.default(this.menuItems);
    }
  }, {
    key: 'addItem',
    value: function addItem(name, description, isVegetarian, price) {
      if (this.length === MAX_ITEMS) {
        _get(Object.getPrototypeOf(LunchMenu.prototype), 'addItem', this).call(this, new _MenuItem2.default(name, description, isVegetarian, price));
      }
    }
  }]);

  return LunchMenu;
}(_Menu3.default);

exports.default = LunchMenu;

},{"../../common/Iterator":6,"../../common/Menu":7,"../../common/MenuItem":8}],3:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _printMenu(iterator) {
  var menuItem = iterator.next();
  while (menuItem.value) {
    console.log(menuItem.value.getName() + ": " + menuItem.value.getDescription() + ", " + menuItem.value.getPrice() + "eur.");
    menuItem = iterator.next();
  }
}

var Mattress = function () {
  function Mattress(menus) {
    _classCallCheck(this, Mattress);

    this.menus = menus;
  }

  _createClass(Mattress, [{
    key: "printMenu",
    value: function printMenu() {
      this.menus.forEach(function (menu) {
        var iterator = menu.createIterator();
        _printMenu(iterator);
      });
    }
  }]);

  return Mattress;
}();

exports.default = Mattress;

},{}],4:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _Menu2 = require('../../common/Menu');

var _Menu3 = _interopRequireDefault(_Menu2);

var _MenuItem = require('../../common/MenuItem');

var _MenuItem2 = _interopRequireDefault(_MenuItem);

var _Iterator = require('../../common/Iterator');

var _Iterator2 = _interopRequireDefault(_Iterator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PancakeHouseMenu = function (_Menu) {
  _inherits(PancakeHouseMenu, _Menu);

  function PancakeHouseMenu() {
    _classCallCheck(this, PancakeHouseMenu);

    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(PancakeHouseMenu).call(this));

    _this.addItem("K&B's Pancake Breakfast", "Pancakes with scrambled eggs, and toast", true, 2.99);
    _this.addItem("Regular Pancake Breakfast", "Pancakes with fried eggs, sausage", false, 2.99);
    _this.addItem("Blueberry Pancakes", "Pancakes made with fresh blueberries", true, 3.49);
    _this.addItem("Waffles", "Waffles, with your choice of blueberries or strawberries", true, 3.59);
    return _this;
  }

  _createClass(PancakeHouseMenu, [{
    key: 'createIterator',
    value: function createIterator() {
      return new _Iterator2.default(this.menuItems);
    }
  }, {
    key: 'addItem',
    value: function addItem(name, description, isVegetarian, price) {
      _get(Object.getPrototypeOf(PancakeHouseMenu.prototype), 'addItem', this).call(this, new _MenuItem2.default(name, description, isVegetarian, price));
    }
  }]);

  return PancakeHouseMenu;
}(_Menu3.default);

exports.default = PancakeHouseMenu;

},{"../../common/Iterator":6,"../../common/Menu":7,"../../common/MenuItem":8}],5:[function(require,module,exports){
'use strict';

var _Mattress = require('./Mattress');

var _Mattress2 = _interopRequireDefault(_Mattress);

var _PancakeHouseMenu = require('./PancakeHouseMenu');

var _PancakeHouseMenu2 = _interopRequireDefault(_PancakeHouseMenu);

var _LunchMenu = require('./LunchMenu');

var _LunchMenu2 = _interopRequireDefault(_LunchMenu);

var _CafeMenu = require('./CafeMenu');

var _CafeMenu2 = _interopRequireDefault(_CafeMenu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var oMattress = new _Mattress2.default([new _PancakeHouseMenu2.default(), new _LunchMenu2.default(), new _CafeMenu2.default()]);
console.log("---------------------------------------------");
oMattress.printMenu();
console.log("---------------------------------------------");

},{"./CafeMenu":1,"./LunchMenu":2,"./Mattress":3,"./PancakeHouseMenu":4}],6:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Iterator = function () {
  function Iterator(menuItems) {
    _classCallCheck(this, Iterator);

    this.iterator = menuItems[Symbol.iterator]();
    this.keys = Object.keys(menuItems);
    this.length = this.keys.length;
  }

  _createClass(Iterator, [{
    key: "next",
    value: function next() {
      return this.iterator.next();
    }
  }, {
    key: "remove",
    value: function remove(key) {
      delete this.menuItems[key];
      this.keys = Object.keys(this.menuItems);
      this.length = this.keys.length;
    }
  }]);

  return Iterator;
}();

exports.default = Iterator;

},{}],7:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Menu = function () {
  function Menu() {
    _classCallCheck(this, Menu);

    this.menuItems = [];
    this.length = 0;
  }

  _createClass(Menu, [{
    key: "addItem",
    value: function addItem(menuItem) {
      this.menuItems.push(menuItem);
      this.length++;
    }
  }, {
    key: "getMenuItems",
    value: function getMenuItems() {
      return this.menuItems;
    }
  }]);

  return Menu;
}();

exports.default = Menu;

},{}],8:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MenuItem = function () {
  function MenuItem(name, description, isVegetarian, price) {
    _classCallCheck(this, MenuItem);

    this.name = name;
    this.description = description;
    this._isVegetarian = isVegetarian;
    this.price = price;
  }

  _createClass(MenuItem, [{
    key: "getName",
    value: function getName() {
      return this.name;
    }
  }, {
    key: "getDescription",
    value: function getDescription() {
      return this.description;
    }
  }, {
    key: "getPrice",
    value: function getPrice() {
      return this.price;
    }
  }, {
    key: "isVegetarian",
    value: function isVegetarian() {
      return this._isVegetarian;
    }
  }]);

  return MenuItem;
}();

exports.default = MenuItem;

},{}]},{},[5])

